<script>
  import { fly } from "svelte/transition";
  import { page } from "$app/stores";
  import { goto } from "$app/navigation";
  export let openalertauth;
</script>

<!-- Global notification live region, render this permanently at the end of the document -->
<div
  aria-live="assertive"
  class="pointer-events-none fixed z-[100] inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6"
>
  <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
    <!--
      Notification panel, dynamically insert this into the live region when it needs to be displayed

      Entering: "transform ease-out duration-300 transition"
        From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        To: "translate-y-0 opacity-100 sm:translate-x-0"
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div
      transition:fly={{
        y: -200,
        duration: 500,
      }}
      class="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg"
    >
      <div class="p-4">
        <div class="flex items-start">
          <div class="shrink-0 pt-0.5" />
          <div class="ml-3 w-0 flex-1">
            <p class="text-sm font-medium text-gray-900">Внимание!</p>
            <p class="mt-1 text-sm text-gray-500">
              Для добавления товара в лист ожидания необходимо войти в аккаунт.
            </p>
            <div class="mt-4 flex">
              <button
                on:click={() => {
                  goto(`/auth/sign-in?pathname=${$page.url.pathname}`);
                }}
                type="button"
                class="inline-flex items-center rounded-md bg-gray-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >Войти</button
              >
              <button
                on:click={() => (openalertauth = false)}
                type="button"
                class="ml-3 inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                >Позже</button
              >
            </div>
          </div>
          <div class="ml-4 flex shrink-0">
            <button
              on:click={() => (openalertauth = false)}
              type="button"
              class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              <span class="sr-only">Close</span>
              <svg
                class="size-5"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
                data-slot="icon"
              >
                <path
                  d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
